module.exports = __webpack_public_path__ + "img/seven-eleven.fd34bc09.svg";